// Formats a minor-unit (cents) amount with thousands separators, e.g.
// formatMoney(123456, "usd") -> "1,234.56 USD".
export function formatMoney(cents, currency) {
  const amount = (Number(cents) || 0) / 100;
  const formatted = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return currency ? `${formatted} ${String(currency).toUpperCase()}` : formatted;
}

// Joins a gateway balance `[{value, currency}]` list into one display string,
// e.g. formatBalanceAmounts([{value: 123456, currency: "usd"}]) -> "1,234.56 USD".
// Pass { skipZero: true } to omit zero-value entries (e.g. for "pending",
// where a zero balance isn't worth showing).
export function formatBalanceAmounts(amounts, { skipZero = false } = {}) {
  if (!amounts?.length) {
    return null;
  }
  const filtered = skipZero ? amounts.filter((a) => a.value) : amounts;
  if (!filtered.length) {
    return null;
  }
  return filtered.map((a) => formatMoney(a.value, a.currency)).join(" + ");
}

// Adds gateway balance `[{value, currency}]` lists together per currency,
// e.g. Crowded's captured + in-transit amounts.
export function addBalanceAmounts(...lists) {
  const totals = new Map();
  for (const list of lists) {
    for (const a of list || []) {
      const key = String(a.currency || "").toLowerCase();
      totals.set(key, (totals.get(key) || 0) + (Number(a.value) || 0));
    }
  }
  return [...totals].map(([currency, value]) => ({ value, currency }));
}
